import {debug} from "helpers/debug";

window.debug = debug;
